import { useEffect, useState } from "react";

function AnimationPage() {

  const [videoUrl, setVideoUrl] = useState("");

  useEffect(() => {

    fetch("https://edunet.kmechengineering.com/root-engine1/api/get-animation?date=2026-06-17&t=" + Date.now())
      .then((res) => res.json())
      .then((data) => {

        console.log(data);

        if (data.status) {
          setVideoUrl(data.video_url);
        }

      });

  }, []);

  return (
    <div>

      <h3>{videoUrl}</h3>

      {videoUrl && (
        <video
          autoPlay
          muted
          loop
          controls
          width="100%"
          src={videoUrl}
        />
      )}

    </div>
  );
}

export default AnimationPage;